import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279c6ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "amount-list rel flex-ter"
}
const _hoisted_2 = { class: "num" }
const _hoisted_3 = {
  key: 0,
  class: "fx-1"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 合計金額 ")
const _hoisted_5 = { class: "rp-color ft-w-6" }
const _hoisted_6 = {
  key: 1,
  class: "fx-1"
}
const _hoisted_7 = { class: "rp-color ft-w-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-up" }, null, -1))
const _hoisted_9 = {
  class: "abs table",
  id: "cartSku"
}
const _hoisted_10 = { class: "flex-ter row head" }
const _hoisted_11 = ["onMouseenter", "onMouseleave"]
const _hoisted_12 = { class: "rel flex-center" }
const _hoisted_13 = { class: "abs" }
const _hoisted_14 = ["onClick"]

import { t } from '@/plugins/i18n'
import { ref, computed, watch, onUnmounted } from 'vue'
import { formatMoney } from '@/plugins/utils'
import { showCurrentUnit } from '@/util/useYan'
import { extProductRespDTO } from '../data'
import { isJA } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
    amount: { type: null, required: true },
    product: { type: null, required: true },
    columns: { type: null, required: true },
    updateNum: { type: null, required: true },
    isMultiGoods: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as {
  amount: any,
  product: extProductRespDTO,
  columns: any,
  updateNum: any,
  isMultiGoods: boolean,
}


const columns = computed(() => props.columns.concat({ type: t('数量') }))
const tNum = computed(() => {
  return Object.values(props.amount).reduce((total: number, v: any): number => {
    return total + v.num
  }, 0)
})
const tPrice = computed(() => {
  return formatMoney(
    Object.values(props.amount).reduce((total: number, v: any): number => {
      return total + v.num * v.productSellPrice
    }, 0)
  )
})
watch(tNum, (v) => {
  if (!v) show.value = false
})
const show = ref(false)
const delay = () => {
  if (!show.value) {
    setTimeout(() => {
      show.value = true
    }, 0)
  }
}
const handle = (e: any) => {
  if (show.value) {
    let tar = e.target
    while (tar && tar.id !== 'cartSku') {
      tar = tar.parentNode
    }
    if (tar === null) {
      show.value = false
    }
  }
}
document.body.addEventListener('click', handle)
onUnmounted(() => {
  document.body.removeEventListener('click', handle)
})

const change = (v: any, n: number | undefined) => {
  v.num = n
  props.updateNum(v)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      (_unref(tNum))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(t)('合计')) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_unref(tNum)), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('件')), 1)
            ]),
            (__props.product?.switchAllIncludePriceJp === 1 && _unref(isJA)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(tPrice)) + "円", 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(t)('商品金额')) + " ", 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(tPrice)), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(showCurrentUnit)(__props.isMultiGoods)), 1)
                ])),
            _createElementVNode("div", {
              class: "up btn",
              onClick: delay
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('已选清单')) + " ", 1),
              _hoisted_8
            ]),
            _createVNode(_Transition, { name: "el-zoom-in-bottom" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("label", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (v) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: v.type
                      }, _toDisplayString(v.type), 1))
                    }), 128))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.amount, (v) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex-ter row",
                      key: v.productProperties,
                      onMouseenter: ($event: any) => (v.show = true),
                      onMouseleave: ($event: any) => (v.show = false)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.productPropertiesName.split(';'), (w) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: w,
                          class: "line--3"
                        }, _toDisplayString(w.split(':').pop()), 1))
                      }), 128)),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(v.num), 1),
                        _withDirectives(_createVNode(_component_el_input_number, {
                          size: "small",
                          modelValue: v.num,
                          "onUpdate:modelValue": ($event: any) => ((v.num) = $event),
                          min: 0,
                          "step-strictly": "",
                          max: 99999,
                          onChange: (e) => change(v, e)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), [
                          [_vShow, v.show]
                        ]),
                        _createElementVNode("span", {
                          class: "abs btn del",
                          onClick: ($event: any) => (change(v, 0))
                        }, "×", 8, _hoisted_14)
                      ])
                    ], 40, _hoisted_11))
                  }), 128))
                ], 512), [
                  [_vShow, show.value]
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})